export default __webpack_public_path__ + "static/media/tech-confluence.89f30129.jpeg";